import AssessmentValidator from './AssessmentValidator';

export default AssessmentValidator;
